/** A measurement date is a calendar day, not a UTC instant. */
export function formatMeasurementDate(date: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);
  if (match) return `${match[3]}/${match[2]}/${match[1]}`;
  return new Date(date).toLocaleDateString('es-PY');
}
